<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
        <md-card>
          <md-card-header data-background-color="green">
            <h4 class="title">Contacts</h4>
            <p class="category">Contact list</p>
          </md-card-header>
          <md-card-content v-if="contacts.length">
            <md-table v-model="contacts" table-header-color="green">
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Contact Email" >
                  <p class="reservation_table-name">
                    {{item.email}}
                  </p>
                </md-table-cell>
                <md-table-cell md-label="Contact Phone">{{item.phone}}</md-table-cell>
                <md-table-cell md-label="Created Date">{{ getDate(item.updated_at) }}</md-table-cell>
                <md-table-cell md-label="Message"><span class="item_message">{{ item.message }}</span></md-table-cell>
                <md-table-cell md-label="">
                  <md-button class="" @click="openMore(item)">
                    more
                  </md-button>
                </md-table-cell>
                <md-table-cell md-label="">
                  <span class="cursor_pointer" @click="openDelete(item.id)">
                    <md-icon class="color_red">delete</md-icon>
                  </span>
                </md-table-cell>
              </md-table-row>
            </md-table>
          </md-card-content>
          <md-table>
            <md-table-cell v-if="!contacts.length"><p class="px-3">No contacts yet. </p></md-table-cell>
          </md-table>
        </md-card>
      </div>
    </div>
    <!--    details  -->
    <md-dialog :md-active.sync="showDialog" class="custom-dialog">
      <md-dialog-title>Contact details</md-dialog-title>
      <div class="md-layout-item md-small-size-100 md-size-100">
        <h4><md-icon>alternate_email</md-icon> {{modalData.email}}</h4>
        <h4><md-icon>phone</md-icon> {{modalData.phone}}</h4>
        <br>
        <p class="px-2 py-4">{{modalData.message}}</p>
      </div>
      <md-dialog-actions>
        <md-button class="md-secondary m-2" @click="showDialog = false">Close</md-button>
      </md-dialog-actions>
    </md-dialog>
    <!--    details  -->

    <!--    del  -->
    <md-dialog :md-active.sync="showDelDialog" class="custom-dialog">
      <md-dialog-title>Delete Contact</md-dialog-title>
      <div class="md-layout-item md-small-size-100 md-size-100">
        <h4>Are you sure you want to delete this contact?</h4>
        <br>
        <p>This action cannot be undone and the contact details will be permanently removed.</p>
      </div>
      <md-dialog-actions>
        <md-button class="md-secondary" @click="showDelDialog = false">Close</md-button>
        <md-button class="md-primary" @click="onConfirmDelete()">Delete</md-button>
      </md-dialog-actions>
    </md-dialog>
    <!--    del  -->

  </div>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "AdminContacts",
  data() {
    return {
      showDialog: false,
      showDelDialog: false,
      delContactId: null,
      contacts: [],
      modalData: {}
    }
  },
  created() {
    this.getAllContacts()
  },
  methods: {
    ...mapActions(['getContacts', 'removeContact']),
    getDate(input) {
      const date = new Date(input);
      const options = { year: 'numeric', month: 'short', day: 'numeric' };
      return date.toLocaleDateString('en-US', options);
    },
    getAllContacts() {
      this.getContacts()
      .then(res => {
        this.contacts = res.data.data
      })
    },
    openDelete(id) {
      this.delContactId = id
      this.showDelDialog = true
    },
    onConfirmDelete() {
      this.removeContact(this.delContactId)
          .then(res => {
            if(res.status == 200) {
              this.showDelDialog = !this.showDelDialog
              this.delContactId = null
              this.getAllContacts()
            }
            if(res.status == 404) {
              this.delError = res.response.data.error
            }
          })
    },
    openMore(item) {
      console.log(item)
      this.showDialog = !this.showDialog
      this.modalData = item
    }
  }
}
</script>

<style scoped lang="scss">
.item_more {
  text-decoration: underline;
}
.item_message {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  max-width: 90px;
}
.md-icon {
  color: #66bb6a !important;
}
.custom-dialog {
  max-width: 50%;
  margin: 0 auto;
}
.color_red {
  color: red !important;
}
</style>
